<ng-container
    *im2mLet="{
        loading: loading$ | async,
        filterParams: filterParams$ | async,
        loggedInUser: loggedInUser$ | async
    } as data"
>
    <liebherr-table-controls [title]="'FIRMWARES.TITLE'" [filterGroups]="filterGroups" [filterControlWidth]="'calc(100% / 3 - 1rem)'">
        <button *ngIf="data.loggedInUser | liebherrPermission : getFirmwarePermissions('addFirmware')" mat-icon-button (click)="onAddFirmware()">
            <mat-icon>add</mat-icon>
        </button>
    </liebherr-table-controls>
    <liebherr-loading *ngIf="data?.loading === true"></liebherr-loading>
    <liebherr-table-container>
        <table
            mat-table
            [dataSource]="dataSource"
            matSort
            [matSortActive]="data?.filterParams?.sortColumn"
            [matSortDirection]="data?.filterParams?.sortAsc ? 'asc' : 'desc'"
            (matSortChange)="routerService.setSortParams($event)"
        >
            <ng-container *ngFor="let column of displayedColumns" [sticky]="column === COLUMNS.VERSION" [stickyEnd]="column === COLUMNS.ACTIONS" [matColumnDef]="column">
                <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="column === COLUMNS.ACTIONS || column === COLUMNS.HAS_FILE">
                    <ng-container *ngIf="column !== COLUMNS.ACTIONS && column !== COLUMNS.HAS_FILE">
                        {{ 'FIRMWARES.COLUMNS.' + (column | uppercase) | transloco }}
                    </ng-container>
                </th>
                <td mat-cell *matCellDef="let element">
                    <ng-container [ngSwitch]="column">
                        <ng-container *ngSwitchCase="COLUMNS.ACTIVE">
                            <span *ngIf="element.activeOn; else inactive" [matTooltip]="'FIRMWARES.ACTIVE_HINT' | transloco">
                                {{ element.activeOn }}
                                <mat-icon class="active outlined">verified</mat-icon>
                            </span>
                            <ng-template #inactive>-</ng-template>
                        </ng-container>
                        <ng-container *ngSwitchCase="COLUMNS.VERSION">
                            {{ element.version || '-' }}
                        </ng-container>
                        <ng-container *ngSwitchCase="COLUMNS.ROUTERTYPE">
                            {{ element.routerType || '-' }}
                        </ng-container>
                        <ng-container *ngSwitchCase="COLUMNS.VENDOR">
                            {{ element.vendor || '-' | uppercase }}
                        </ng-container>
                        <ng-container *ngSwitchCase="COLUMNS.RELEASED_AT">
                            {{ element.releasedAt ? (element.releasedAt | liebherMarkAsUTC | date : ('DATE_FORMAT' | transloco)) : '-' }}
                        </ng-container>
                        <ng-container *ngSwitchCase="COLUMNS.RELEASED_BY">
                            {{ element.releasedBy?.username || '-' }}
                        </ng-container>
                        <ng-container *ngSwitchCase="COLUMNS.HAS_FILE">
                            <mat-icon *ngIf="!element.hasFile" [matTooltip]="'FIRMWARES.NO_FILE_HINT' | transloco">block</mat-icon>
                        </ng-container>
                        <ng-container *ngSwitchCase="COLUMNS.ACTIONS">
                            <liebherr-action-menu *ngIf="actionMenuItems.length > 0" (action)="onActionMenuClick($event, element)">
                                <liebherr-action-menu-item *ngFor="let item of actionMenuItems" [item]="item" [disabled]="item.event === ACTION.DELETE ? element?.active : false">
                                </liebherr-action-menu-item>
                            </liebherr-action-menu>
                        </ng-container>
                    </ng-container>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
    </liebherr-table-container>

    <liebherr-no-data *ngIf="dataSource.data.length === 0 && !data?.loading"></liebherr-no-data>
    <mat-paginator (page)="routerService.setPageParams($event)" [pageSize]="data?.filterParams?.rowLimit" [pageIndex]="data?.filterParams?.page"></mat-paginator>
</ng-container>
